const menuList = [
  { title: 'message.layout.dashboard', icon: 'analytics', to: '/dashboard' },
  { title: 'message.layout.crm', icon: 'assignment_ind', to: '/customers' },
  { title: 'message.order.orderOffer', icon: 'add_shopping_cart', to: '/orders' },
  { title: 'message.layout.invoices', icon: 'mdi-currency-usd', to: '/invoices', hideForTechRole: true },
  { title: 'message.layout.warehouse', icon: 'business', to: '/w_h' },
  { title: 'message.layout.hse', icon: 'assessment', to: '/hse' },
  { title: 'message.layout.ticket', icon: 'style', to: '/tickets', hasNotification: false },
  { title: 'message.layout.deviation', icon: 'mdi-alert-box-outline', to: '/deviations' },
  { title: 'message.layout.deviationMeasures', icon: 'mdi-folder-alert-outline', to: '/deviation_measures' },
  { title: 'message.layout.reports', icon: 'mdi-developer-board', to: '/reports', hideForTechRole: true },
  { title: 'message.document.builder', icon: 'mdi-cloud-tags', to: '/document_builder', hideForTechRole: true },
  { title: 'message.layout.user', icon: 'mdi-clipboard-account', to: '/users' },
  {
    title: 'message.layout.crmSettings',
    icon: 'mdi-account-settings',
    isSettings: true,
    hasChildren: true,
    hideForTechRole: true,
    hideForOffice: true,
    children: [
      { title: 'message.layout.priority', icon: 'mdi-marker-check', to: '/crm_priorities' },
      { title: 'message.layout.shipments', icon: 'mdi-truck-delivery', to: '/crm_shipments' },
      { title: 'message.layout.industries', icon: 'mdi-factory', to: '/crm_industries' },
      { title: 'message.order.paymentTerms', icon: 'mdi-bank', to: '/payment_terms' },
      { title: 'message.order.deliveryTerm', icon: 'mdi-truck', to: '/delivery_terms' }
    ]
  },
  { title: 'message.settings.generalSettings', icon: 'mdi-cogs', to: '/general_settings', hideForTechRole: true, hideForOffice: true },
  { title: 'message.layout.invoiceSettings', icon: 'mdi-cog-box', to: '/invoice_settings', hideForTechRole: true, hideForOffice: true },
  // { title: 'message.layout.userRole', icon: 'layers', to: '/user_roles' },
  // { title: 'message.layout.permission', icon: 'fingerprint', to: '/permissions' },
  { title: 'message.layout.groups', icon: 'mdi-server-network', to: '/groups', hideForTechRole: true, hideForOffice: true },
  { title: 'message.layout.currencies', icon: 'mdi-currency-eur', to: '/currencies', hideForTechRole: true, hideForOffice: true },
  { title: 'message.layout.salesAccounts', icon: 'mdi-sale', to: '/salesaccounts', hideForTechRole: true, hideForOffice: true },
  { title: 'message.layout.sharepointSetting', icon: 'mdi-cloud', to: '/sharepoint', hideForTechRole: true, hideForOffice: true },
  {
    title: 'message.layout.tickets',
    icon: 'mdi-ticket',
    hideForTechRole: true,
    hideForOffice: true,
    hasChildren: true,
    children: [
      { title: 'message.systemConfiguration.systemConfig', icon: 'mdi-chip', to: '/ticketing_configuration' },
      { title: 'message.layout.priority', icon: 'mdi-marker-check', to: '/priorities' },
      { title: 'message.layout.category', icon: 'mdi-hexagon-multiple', to: '/categories' },
      { title: 'message.layout.status', icon: 'mdi-widgets', to: '/ticket_status' },
      { title: 'message.layout.types', icon: 'mdi-cards-variant', to: '/ticket_types' },
      { title: 'message.layout.mailConfiguration', icon: 'mdi-email', to: '/mail_configuration' },
      { title: 'message.layout.mailAddressFilter', icon: 'mdi-email-fast', to: '/mailaddressfilter' },
      { title: 'message.layout.advanced', icon: 'mdi-refresh-auto', to: '/tickets-advanced-settings' }
    ]
  },
  {
    title: 'message.layout.deviations',
    icon: 'mdi-chart-line-stacked',
    hideForTechRole: true,
    hideForOffice: true,
    hasChildren: true,
    children: [
      { title: 'message.layout.measureStatus', icon: 'mdi-marker-check', to: '/measures_status' },
      { title: 'message.layout.measureCategory', icon: 'mdi-format-list-group', to: '/measure_category' },
      { title: 'message.layout.category', icon: 'mdi-equal-box', to: '/deviation_category' },
      { title: 'message.layout.location', icon: 'mdi-map-marker-plus', to: '/deviation_location' },
      { title: 'message.layout.deviationSettingStatus', icon: 'mdi-widgets', to: '/deviation_status' }
    ]
  },
  // {
  //   title: '',
  //   icon: '',
  //   hasChildren: true,
  //   children: [
  //     { title: , icon: 'mdi-cloud', , notOther: true },
  //     { title: 'message.layout.sharepointCredential', icon: 'mdi-security', to: '/sharepoint_credential' }
  //   ]
  // },
  {
    title: 'message.layout.warehouse',
    icon: 'mdi-warehouse',
    hasChildren: true,
    hideForTechRole: true,
    hideForOffice: true,
    children: [
      { title: 'message.layout.warehouse', icon: 'mdi-warehouse', to: '/settings/warehouse' },
      { title: 'message.layout.warehouseLocations', icon: 'mdi-map-marker', to: '/warehouse_location' },
      { title: 'message.layout.productUnit', icon: 'business_center', to: '/product_units' },
      { title: 'message.layout.productGroup', icon: 'wysiwyg', to: '/product_groups' },
      { title: 'message.layout.grossMargin', icon: 'mdi-chart-bar-stacked', to: '/grossmargins' },
      { title: 'message.layout.discountGroups', icon: 'mdi-percent', to: '/discountgroups' }
    ]
  },
  {
    title: 'message.layout.checklist',
    icon: 'mdi-note-text',
    hideForTechRole: true,
    hideForOffice: true,
    hasChildren: true,
    children: [
      { title: 'Templates', icon: 'mdi-equal-box', to: '/checklist_templates' },
      { title: 'Properties', icon: 'mdi-marker-check', to: '/properties' }
    ]
  },
  {
    title: 'message.form.documents',
    icon: 'mdi-file',
    hideForTechRole: true,
    hideForOffice: true,
    hasChildren: true,
    children: [
      { title: 'message.props.template', icon: 'mdi-file-multiple', to: '/document_template' }
    ]
  }
]
export default menuList
